import { GlobalStore } from "../../types/store";

export const getPaymentsStatus = (state: GlobalStore) =>
  state.payments.data.status.enabled;

export const getMCCs = (state: GlobalStore) => state.payments.data.mccs;
